import { TCreateConverter, TFetchConverter } from '../types/Converter.types';
import {
  EResetPasswordCasesDb,
  EResetPasswordCasesUI,
  TResetPasswordCasesDb,
  TResetPasswordCasesUI,
  TResetPasswordDb,
  TResetPasswordFormDb,
  TResetPasswordFormUI,
  TResetPasswordUI,
  TSetPasswordFormDb,
  TSetPasswordFormUI,
} from '../types/Auth.types';

export const resetPasswordCasesConverter: TCreateConverter<
  TResetPasswordCasesUI,
  TResetPasswordCasesDb
> = {
  toDb: ({ email }) => ({ username: email.trim() }),
};

const resetPasswordStatusMapper: {
  [key in EResetPasswordCasesDb]: EResetPasswordCasesUI;
} = {
  [EResetPasswordCasesDb.RESEND_INVITATION]:
    EResetPasswordCasesUI.RESEND_INVITATION,
  [EResetPasswordCasesDb.RESENT_CODE]: EResetPasswordCasesUI.RESENT_CODE,
  [EResetPasswordCasesDb.RESENT_PASSWORD]:
    EResetPasswordCasesUI.RESENT_PASSWORD,
};

export const resetPasswordConverter: TFetchConverter<
  TResetPasswordUI,
  TResetPasswordDb
> = {
  fromDb: data => ({
    passwordResendStatus: resetPasswordStatusMapper[data.passwordResendStatus],
    isAdmin: data.admin,
  }),
};

export const resetPasswordFormConverter: TCreateConverter<
  TResetPasswordFormUI,
  TResetPasswordFormDb
> = {
  toDb: ({ email, password, code }) => ({
    username: email.trim(),
    password,
    code: code.trim(),
  }),
};

export const setNewPasswordConverter: TCreateConverter<
  TSetPasswordFormUI,
  TSetPasswordFormDb
> = {
  toDb: ({ password, email, temporaryPassword }) => ({
    temporaryPassword,
    username: email.trim(),
    newPassword: password,
  }),
};
